export default __webpack_public_path__ + "images/match-mvp-star-9fa28.svg";